export default __webpack_public_path__ + "static/Roboto-Medium-13a29228654d5c5ec9c482a267efa4af.ttf";